import {envPaths} from '~/utils/services/paths';

export type ICpEnv = {
  additionalTaxInfo: 'hide' | 'optional' | 'required';
  categoryTreeUrl: string;
  featureFlags: Record<string, boolean>;
  fid: {
    enabled: boolean;
    gsi_clientId: string;
    gsi_clientId_android: string;
    gsi_clientId_ios: string;
  };
  rfcGenericForeignPattern: string;
  rfcGenericNationalPattern: string;
  rfcPattern: string;
  sessionToken: string;
  minRequiredVersion?: string;
  notificationSettingEnabled?: boolean;
}

export const getEnv = () => {
  return $cpFetch<ICpEnv>(envPaths.env);
};
